/**
 * Centralized cookie name constants.
 */

export const COOKIES = {
  // BE httpOnly cookie name for admin access
  BACKEND_ADMIN_SID: "admin_sid",
  // FE-managed cookies (temporary until BE cookies are reliable)
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  USER_EMAIL: "userEmail",
  USER_NAME: "userName",
} as const;

export type CookieKey = keyof typeof COOKIES;

